
import LazyImage from '@/components/lazy-image';
import Typography from '@/ui-kit/components/typography';
import Button from '@/ui-kit/components/button';
import WindowSize from '@/ui-kit/mixins/windowSize';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import { StyleColorSchemeType, StyleFontWeightType, StyleSizeType } from '@/ui-kit/styles/enums';
import { Breakpoints } from '@/ui-kit/styles/constants';
import ImageHelper from '@/utils/ImageHelper';
import { Comparator } from '@/ui-kit/enums';

export default {
  name: 'ContentInfoCard',
  components: {
    LazyImage,
    Typography,
    Button,
  },
  mixins: [WindowSize],
  props: {
    data: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      TypographyType,
      StyleColorSchemeType,
      StyleFontWeightType,
      StyleSizeType,
      ButtonFillType,
    };
  },
  computed: {
    imageRatio() {
      return ImageHelper.constructor.getImageRatio(this.data.image.dimensions);
    },
    heroImageSizes() {
      return [
        {
          comparator: Comparator.Less,
          breakpoint: Breakpoints.XSmall,
          imageSize: 400,
        },
        {
          comparator: Comparator.Greater,
          breakpoint: Breakpoints.Medium,
          imageSize: 600,
        },
      ];
    },
  },
  methods: {
    handleTrackEvent(type = 'click-primary-button') {
      this.$emit(type);
    },
  },
};
